import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './InterviewsPage.css';

const InterviewsPage = () => {
  const [interviews, setInterviews] = useState([]);
  const [filteredInterviews, setFilteredInterviews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedType, setSelectedType] = useState('all');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('newest');
  const interviewsPerPage = 12;

  useEffect(() => {
    const sampleInterviews = Array.from({ length: 80 }, (_, index) => ({
      id: index + 1,
      title: `حوار رقم ${index + 1}`,
      interviewee: `الضيف ${Math.floor(Math.random() * 25) + 1}`,
      interviewer: `المحاور ${Math.floor(Math.random() * 5) + 1}`,
      type: ['مقابلة مكتوبة', 'مقابلة صوتية', 'مقابلة مرئية'][Math.floor(Math.random() * 3)],
      category: ['كاتب', 'شاعر', 'رسام', 'ناقد أدبي', 'مثقف'][Math.floor(Math.random() * 5)],
      summary: `ملخص للحوار رقم ${index + 1} الذي يتناول مواضيع مهمة ومثيرة للاهتمام`,
      content: `محتوى الحوار الكامل رقم ${index + 1}...`,
      publishDate: new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1),
      duration: Math.floor(Math.random() * 60) + 15,
      views: Math.floor(Math.random() * 1000) + 100,
      likes: Math.floor(Math.random() * 50) + 10,
      tags: ['أدب', 'ثقافة', 'فن', 'شعر', 'كتابة'].slice(0, Math.floor(Math.random() * 3) + 1),
      featured: Math.random() > 0.8
    }));
    setInterviews(sampleInterviews);
    setFilteredInterviews(sampleInterviews);
  }, []);

  useEffect(() => {
    let filtered = interviews;

    if (searchTerm) {
      filtered = filtered.filter(interview => 
        interview.title.includes(searchTerm) || 
        interview.interviewee.includes(searchTerm) ||
        interview.summary.includes(searchTerm) ||
        interview.tags.some(tag => tag.includes(searchTerm))
      );
    }

    if (selectedType !== 'all') {
      filtered = filtered.filter(interview => interview.type === selectedType);
    }

    if (selectedCategory !== 'all') {
      filtered = filtered.filter(interview => interview.category === selectedCategory);
    }

    filtered = filtered.sort((a, b) => {
      switch (sortBy) {
        case 'newest':
          return new Date(b.publishDate) - new Date(a.publishDate);
        case 'oldest':
          return new Date(a.publishDate) - new Date(b.publishDate);
        case 'title':
          return a.title.localeCompare(b.title);
        case 'interviewee':
          return a.interviewee.localeCompare(b.interviewee);
        case 'popular':
          return b.views - a.views;
        case 'likes':
          return b.likes - a.likes;
        default:
          return 0;
      }
    });

    setFilteredInterviews(filtered);
    setCurrentPage(1);
  }, [interviews, searchTerm, selectedType, selectedCategory, sortBy]);

  const indexOfLastInterview = currentPage * interviewsPerPage;
  const indexOfFirstInterview = indexOfLastInterview - interviewsPerPage;
  const currentInterviews = filteredInterviews.slice(indexOfFirstInterview, indexOfLastInterview);
  const totalPages = Math.ceil(filteredInterviews.length / interviewsPerPage);

  const types = ['all', 'مقابلة مكتوبة', 'مقابلة صوتية', 'مقابلة مرئية'];
  const categories = ['all', 'كاتب', 'شاعر', 'رسام', 'ناقد أدبي', 'مثقف'];

  const getTypeIcon = (type) => {
    switch (type) {
      case 'مقابلة مكتوبة':
        return 'fas fa-file-alt';
      case 'مقابلة صوتية':
        return 'fas fa-microphone';
      case 'مقابلة مرئية':
        return 'fas fa-video';
      default:
        return 'fas fa-comments';
    }
  };

  const featuredInterviews = interviews.filter(interview => interview.featured).slice(0, 3);

  return (
    <div className="interviews-page">
      <div className="page-header">
        <div className="container">
          <h1>الحوارات الصحفية</h1>
          <p>اقرأ واستمع لحوارات شيقة مع كتابنا وفنانينا المبدعين</p>
        </div>
      </div>

      {featuredInterviews.length > 0 && (
        <section className="featured-interviews">
          <div className="container">
            <h2>حوارات مميزة</h2>
            <div className="featured-grid">
              {featuredInterviews.map((interview) => (
                <div key={interview.id} className="featured-interview-card">
                  <div className="featured-interview-image">
                    <i className={getTypeIcon(interview.type)}></i>
                    <div className="featured-badge">مميز</div>
                  </div>
                  <div className="featured-interview-info">
                    <span className="interview-type">{interview.type}</span>
                    <h3>{interview.title}</h3>
                    <p className="interviewee">مع: {interview.interviewee}</p>
                    <p className="summary">{interview.summary}</p>
                    <div className="interview-stats">
                      <span><i className="fas fa-eye"></i> {interview.views}</span>
                      <span><i className="fas fa-heart"></i> {interview.likes}</span>
                      <span><i className="fas fa-clock"></i> {interview.duration} دقيقة</span>
                    </div>
                    <Link to={`/interviews/${interview.id}`} className="btn btn-primary">
                      قراءة الحوار
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <div className="interviews-content">
        <div className="container">
          <div className="interviews-controls">
            <div className="search-box">
              <i className="fas fa-search"></i>
              <input
                type="text"
                placeholder="ابحث عن حوار أو ضيف..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="filter-controls">
              <select
                value={selectedType}
                onChange={(e) => setSelectedType(e.target.value)}
                className="filter-select"
              >
                <option value="all">جميع الأنواع</option>
                {types.slice(1).map(type => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>

              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="filter-select"
              >
                <option value="all">جميع الفئات</option>
                {categories.slice(1).map(category => (
                  <option key={category} value={category}>{category}</option>
                ))}
              </select>

              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="filter-select"
              >
                <option value="newest">الأحدث</option>
                <option value="oldest">الأقدم</option>
                <option value="title">حسب العنوان</option>
                <option value="interviewee">حسب الضيف</option>
                <option value="popular">الأكثر مشاهدة</option>
                <option value="likes">الأكثر إعجاباً</option>
              </select>
            </div>
          </div>

          <div className="results-info">
            <p>عرض {indexOfFirstInterview + 1}-{Math.min(indexOfLastInterview, filteredInterviews.length)} من {filteredInterviews.length} حوار</p>
          </div>

          <div className="interviews-grid">
            {currentInterviews.map((interview) => (
              <div key={interview.id} className="interview-card interview-card-modern">
                <div className="interview-image card-image-section">
                  <div className="type-icon-large">
                    <i className={getTypeIcon(interview.type)}></i>
                  </div>
                  <div className="card-overlay">
                    <span className="interview-type type-badge-modern">{interview.type}</span>
                    <div className="quick-stats">
                      <span><i className="fas fa-eye"></i> {interview.views}</span>
                      <span><i className="fas fa-heart"></i> {interview.likes}</span>
                    </div>
                  </div>
                </div>
                
                <div className="interview-info card-content-modern">
                  <div className="card-header-info">
                    <span className="category category-tag">{interview.category}</span>
                    <span className="publish-date">{interview.publishDate.toLocaleDateString('ar-EG')}</span>
                  </div>
                  
                  <h3 className="interview-title card-title">{interview.title}</h3>
                  <p className="interviewee card-guest">مع الضيف: <strong>{interview.interviewee}</strong></p>
                  <p className="summary card-summary">{interview.summary}</p>
                  
                  <div className="interview-tags card-tags">
                    {interview.tags.map((tag, index) => (
                      <span key={index} className="tag modern-tag">{tag}</span>
                    ))}
                  </div>
                  
                  <div className="interview-actions card-footer">
                    <div className="duration-info">
                      <i className="fas fa-clock"></i>
                      <span>{interview.duration} دقيقة</span>
                    </div>
                    <Link to={`/interviews/${interview.id}`} className="btn btn-primary btn-modern">
                      {interview.type === 'مقابلة مكتوبة' ? 'قراءة' : 
                       interview.type === 'مقابلة صوتية' ? 'استماع' : 'مشاهدة'}
                      <i className="fas fa-arrow-left"></i>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {totalPages > 1 && (
            <div className="pagination">
              <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="pagination-btn"
              >
                <i className="fas fa-chevron-right"></i>
              </button>

              {Array.from({ length: Math.min(5, totalPages) }, (_, index) => {
                let pageNumber;
                if (totalPages <= 5) {
                  pageNumber = index + 1;
                } else if (currentPage <= 3) {
                  pageNumber = index + 1;
                } else if (currentPage >= totalPages - 2) {
                  pageNumber = totalPages - 4 + index;
                } else {
                  pageNumber = currentPage - 2 + index;
                }

                return (
                  <button
                    key={pageNumber}
                    onClick={() => setCurrentPage(pageNumber)}
                    className={`pagination-btn ${currentPage === pageNumber ? 'active' : ''}`}
                  >
                    {pageNumber}
                  </button>
                );
              })}

              <button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="pagination-btn"
              >
                <i className="fas fa-chevron-left"></i>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InterviewsPage;
